import React from 'react';

const OrderStatusCompleted = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#00CE64"
        d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2z"
      />
      <path
        fill="#FFF"
        d="M7.713 11.297a1.002 1.002 0 0 0-1.415.01.997.997 0 0 0 .01 1.411l3.045 2.997c.371.366.962.385 1.357.044l6.954-6.003a.997.997 0 0 0 .102-1.408 1.002 1.002 0 0 0-1.41-.102l-6.256 5.4-2.387-2.35z"
      />
    </g>
  </svg>
);

export default OrderStatusCompleted;
